(()=>{
  if (customElements.get('variant-picker')) return;

  // Money formatter with safe fallbacks
  function formatMoney(cents){
    try{
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function'){
        // Use theme money format if available, otherwise rely on Shopify default
        const fmt = (window.theme && (window.theme.moneyFormat || window.theme.money_format)) || undefined;
        return fmt ? window.Shopify.formatMoney(cents, fmt) : window.Shopify.formatMoney(cents);
      }
    }catch(e){}
    const n = (Number(cents||0)/100).toFixed(2);
    return `$${n}`;
  }

    class VariantPicker extends HTMLElement{
      connectedCallback(){
        this.sectionId = this.getAttribute('data-section');
        this.root = this.closest('.section-' + this.sectionId) || document;
        this.form = this.root.querySelector('#product-form-' + this.sectionId) || this.root.querySelector('form[action*="/cart/add"]') || this.root.querySelector('form');
        this.hiddenId = this.form ? this.form.querySelector('[name="id"]') : null;
        try{
          this.variants = JSON.parse(this.querySelector('.vp-data-variants').textContent || '[]');
        }catch(e){ this.variants = []; }
        try{
          this.optionsMeta = JSON.parse(this.querySelector('.vp-data-options').textContent || '[]');
        }catch(e){ this.optionsMeta = []; }
        this.optionCount = this.optionsMeta.length;
        this.dosageMap = { 'Small':'0-25 lbs', 'Medium':'26-50 lbs', 'Large':'51-80 lbs', 'XL':'>80 lbs' };
        const dosageGroup = this.querySelector('.vp-group[data-option-index="2"]');
        if(dosageGroup){
          dosageGroup.querySelectorAll('.vp-option').forEach(btn=>{
            const v = btn.getAttribute('data-base') || btn.getAttribute('data-value');
            const sub = btn.querySelector('[data-sub]');
            if(sub){ sub.textContent = this.dosageMap[v] || ''; }
          });
        }
        this.bind();
        const vid = this.findVariantIdByOptions(this.getSelectedOptions()) || (this.variants[0] && this.variants[0].id);
        this.updateHiddenId(vid);
        requestAnimationFrame(() => this.updateHiddenId(vid));
      }
      bind(){
        this.querySelectorAll('.vp-group').forEach(group=>{
          group.addEventListener('click', e=>{
            const btn = e.target.closest('.vp-option');
            if(!btn) return;
            if(btn.hasAttribute('disabled') || btn.classList.contains('disabled')) return;
            this.setActiveInGroup(group, btn);
            const opts = this.getSelectedOptions();
            const vid = this.findVariantIdByOptions(opts);
            this.updateHiddenId(vid);
            this.updateAvailability(opts);
            this.updateHeaderCurrent(group);
          });
          // Keyboard support for Enter/Space
          group.addEventListener('keydown', e=>{
            if(e.key !== 'Enter' && e.key !== ' ') return;
            const btn = e.target.closest('.vp-option');
            if(!btn) return;
            if(btn.hasAttribute('disabled') || btn.classList.contains('disabled')) return;
            e.preventDefault();
            this.setActiveInGroup(group, btn);
            const opts = this.getSelectedOptions();
            const vid = this.findVariantIdByOptions(opts);
            this.updateHiddenId(vid);
            this.updateAvailability(opts);
            this.updateHeaderCurrent(group);
          });
        });
        this.updateAvailability(this.getSelectedOptions());
        this.querySelectorAll('.vp-group').forEach(g=>this.updateHeaderCurrent(g));
      }
      getSelectedOptions(){
        const opts = [];
        this.querySelectorAll('.vp-group').forEach(group=>{
          const btn = group.querySelector('.vp-option.active');
          opts.push(btn ? btn.getAttribute('data-value') : null);
        });
        return opts;
      }
      findVariantIdByOptions(opts){
        const v = this.variants.find(v=>{
          if(this.optionCount > 0 && v.option1 != opts[0]) return false;
          if(this.optionCount > 1 && v.option2 != opts[1]) return false;
          if(this.optionCount > 2 && v.option3 != opts[2]) return false;
          return true;
        });
        return v && v.id;
      }
      updateHiddenId(variantId){
        if(!variantId) return;
        const idStr = String(variantId);
        if(this.hiddenId){
          this.hiddenId.value = idStr;
          this.hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
        } 
        const scope = this.root || document; 
        // Quantity rule:
        // - Subscribe active => qty = 1
        // - One-time => qty from active option in group 0 (data-qty)
        const isSubscribeActive = !!document.querySelector('.sub-figma__card.is-active');
        let qty = 1;
        
          const activeQtyOpt = this.querySelector('.vp-group[data-option-index="0"] .vp-option.active');
          qty = parseInt((activeQtyOpt && activeQtyOpt.getAttribute('data-qty')) || '1', 10) || 1;
        
        
        scope.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(f=>{
          const input = f.querySelector('input[name="id"]'); 
          if(input){
            input.value = idStr;
          }  
          const qtyInput = f.querySelector('input[name="quantity"]');
          if(qtyInput){
            qtyInput.value = qty; 
          }
        });
       
        const v = this.variants.find(x => String(x.id) === idStr);
        const available = v ? (v.available !== false) : false;
        const priceCents = v ? Number(v.price) : 0;
        const cmpCents = v && v.compare_at_price ? Number(v.compare_at_price) : 0;
        const discountPct = v && typeof v.discount_percent !== 'undefined' ? Number(v.discount_percent) : 0;
        const discountedCents = Math.round(priceCents * (1 - (isNaN(discountPct)?0:discountPct)/100));
        const hasMetaDiscount = discountPct > 0;
      /*  console.log('hasMetaDiscount', hasMetaDiscount);
        console.log('discountPct', discountPct);
        console.log('discountedCents', discountedCents);*/
        const priceRoot = this.root || document;
        const currentPriceEl = priceRoot.querySelector('.price-current');
        const comparePriceEl = priceRoot.querySelector('.price-compare');
        const badgeEl = priceRoot.querySelector('.price-badge');
        const isSubscribeActivePrice = !!document.querySelector('.sub-figma__card.subscribe.is-active');
        if(!isSubscribeActivePrice){
          
          const currentCents = discountedCents;
          if(currentPriceEl){
            currentPriceEl.textContent = formatMoney(currentCents); 
          }
          if(comparePriceEl){
            let showCompare = false;
            let compareVal = 0;
            if(hasMetaDiscount){
              showCompare = discountedCents;
              compareVal = priceCents;
            } else if (v && cmpCents && cmpCents > priceCents){
              showCompare = true;
              compareVal = cmpCents;
            }
            comparePriceEl.textContent = showCompare ? formatMoney(compareVal) : '';
          //  comparePriceEl.style.display = showCompare ? '' : 'none';
          }
        }
      
        if (badgeEl) {
          const currentCents = hasMetaDiscount ? discountedCents : priceCents;
          const baseForPct = hasMetaDiscount ? priceCents : (cmpCents || 0);
          let pct = 0;
          if(baseForPct > 0 && baseForPct > currentCents){
            pct = Math.round(((baseForPct - currentCents) / baseForPct) * 100);
          }
          if (pct > 0) {
            badgeEl.textContent = `${pct}% OFF`;
            badgeEl.style.display = '';
          } else {
            badgeEl.style.display = 'none';
          }
        }
        // Expose discount metafield and reflect on active option (group 0)
        if(v &&  v.discount_percent != 0){
          this.dataset.selectedDiscount = String(v.discount_percent || 0); 
          const activeQty = this.querySelector('.vp-group[data-option-index="0"].onetime-plan .vp-option.active');
          if(activeQty){ activeQty.dataset.discount = String(v.discount_percent || 0); }
        } else {  
          delete this.dataset.selectedDiscount;
        }
        scope.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(f=>{
          const cta = f.querySelector('[type="submit"]') || f.querySelector('.buy-button__cta');
          if(cta){
            // Ensure aria-disabled is not present
            cta.removeAttribute('aria-disabled');
            cta.toggleAttribute('disabled', !available);
            const priceEl = cta.querySelector('.btn__price');
            const compareEl = cta.querySelector('.btn__compare');
            // Price follows pdp-price.js style: apply discount_percent when present
            const finalPrice = hasMetaDiscount ? discountedCents : priceCents;
            const finalPriceFormatted = formatMoney(finalPrice);
            
            if(!isSubscribeActivePrice){
              if(priceEl){ priceEl.textContent = finalPriceFormatted; }
            }

            if(compareEl){
              let showCompare = false;
              let compareVal = 0;
              if(hasMetaDiscount){
                showCompare = priceCents > discountedCents;
                compareVal = priceCents;
              } else if (v && cmpCents && cmpCents > priceCents){
                showCompare = true;
                compareVal = cmpCents;
              }

              currentPriceEl.textContent = finalPriceFormatted;
              compareEl.textContent = showCompare ? formatMoney(compareVal) : '';
              if( priceCents > hasMetaDiscount){
                compareEl.style.display = 'block';
              }else{
                compareEl.style.display = 'none';
              }
            }
          }
        });
        
        // Update one-time purchase price in subscription widget (reuse calculated values)
        if(!isSubscribeActivePrice){
          const oneTimePrice = scope.querySelector('.sub-figma__card.onetime .sub-figma__price-current');
          const oneTimeCompare = scope.querySelector('.sub-figma__card.onetime .sub-figma__price-compare');
          
          const finalPrice = hasMetaDiscount ? discountedCents : priceCents;
          if(oneTimePrice){
            oneTimePrice.textContent = formatMoney(finalPrice);
          }
          
          // Hide compare price if it equals the current price
          if(oneTimePrice && oneTimeCompare){
            const currentPriceText = oneTimePrice.textContent.trim();
            const comparePriceText = oneTimeCompare.textContent.trim();
            
            if(currentPriceText === comparePriceText || comparePriceText === ''){
              oneTimeCompare.style.display = 'none';
            } else {
              oneTimeCompare.style.display = 'inline';
            }
          }
        }
        const discountAmountCents = hasMetaDiscount ? (priceCents - discountedCents) : 0;
        this.dispatchEvent(new CustomEvent('variant-change', { detail: {
          variant: v,
          pricing: {
            original_cents: priceCents,
            discounted_cents: hasMetaDiscount ? discountedCents : priceCents,
            compare_at_cents: hasMetaDiscount ? priceCents : cmpCents,
            discount_percent: discountPct || 0,
            discount_amount_cents: discountAmountCents
          }
        }, bubbles: true }));
      }
      setActiveInGroup(group, btn){
        group.querySelectorAll('.vp-option').forEach(b=>{
          b.classList.remove('active');
          b.setAttribute('aria-checked','false');
          b.tabIndex = 0;
        });
        btn.classList.add('active');
        btn.setAttribute('aria-checked','true');
        btn.tabIndex = 0;
        // Move focus to selected for better SR announcement
        btn.focus({preventScroll:true});
      }
      updateAvailability(partial){
        this.querySelectorAll('.vp-group').forEach((group, gi)=>{
          group.querySelectorAll('.vp-option').forEach(btn=>{
            const value = btn.getAttribute('data-value');
            const candidate = [...partial];
            candidate[gi] = value;
            const leadsToAny = this.variants.some(v=>{
              if(this.optionCount > 0 && candidate[0] && v.option1 != candidate[0]) return false;
              if(this.optionCount > 1 && candidate[1] && v.option2 != candidate[1]) return false;
              if(this.optionCount > 2 && candidate[2] && v.option3 != candidate[2]) return false;
              return v.available !== false; // prefer available
            });
            btn.toggleAttribute('disabled', !leadsToAny);
            btn.classList.toggle('disabled', !leadsToAny);
            btn.setAttribute('aria-disabled', !leadsToAny ? 'true' : 'false');
            btn.tabIndex = !leadsToAny ? -1 : 0;
          });
        });
      }
      updateHeaderCurrent(group){
        const idx = parseInt(group.getAttribute('data-option-index')||'0',10);
        const current = group.querySelector('.vp-option.active');
        const target = group.querySelector('.vp-header__current');
        if(target){
          const base = current ? (current.getAttribute('data-base') || current.textContent.trim()) : '';
          target.textContent = base;
        }
      }
    }
    customElements.define('variant-picker', VariantPicker);
})();
